export class Order {
    constructor(permalink, transactionId, ssoId) {
        this.permalink = permalink;
        this.transactionId = transactionId;
        this.ssoId = ssoId;
        
        this.form = document.querySelector('#form-landingpage-checkout');
        this.passwordError = document.querySelector('.password-error');
        this.inputSsoid = document.querySelector('[name="customer[ssoid]"]');
        
        this.init();
    };
    
    init() {
        this.form.addEventListener('submit', event => {
            event.preventDefault();
            let request = new Request('POST', this.form.getAttribute('action'));
            request.formData = this.form;

            request.call(response => {
                if(response.status == 'ok') {
                    this.orderFinish();
                } else {
                    let textField = this.passwordError.querySelector('p');
                    if (textField) {
                        textField.innerHTML = response.message;
                    }
                    this.passwordError.classList.remove('d-none');
                }
            });
        });
        
        if(this.permalink && this.transactionId != 0) {
            this.checkOrder();
        } else {
            if (this.ssoId && this.ssoId != 0) {
                this.orderPassword(this.ssoId);
            } else {
                this.orderFinish();
            }
        }
    };
    
    checkOrder() {
        let request = new Request('GET', '/angebote' + this.permalink + '/order/' + this.transactionId);
        request.call(response => {
            if(response.status == 'ok') {
                if(response.data.ssoId && response.data.ssoId != '') {
                    this.orderPassword(response.data.ssoId);
                } else {
                    this.orderFinish();
                }
            }
            if(response.status == 'wait') {
                this.checkOrder();
            }
            if(response.status == 'error') {
                // Error
                console.log(response);
            }
        });
    };
    
    orderFinish() {
        OVS.app.helper.addClass('.order-progress', 'd-none');
        OVS.app.helper.addClass('.order-success-password', 'd-none');
        OVS.app.helper.removeClass('.order-success', 'd-none');
    };
    
    orderPassword(ssoId) {
        OVS.app.helper.addClass('.order-progress', 'd-none');
        OVS.app.helper.removeClass('.order-success-password', 'd-none');
        this.inputSsoid.value = ssoId;
    };
};
